export default (ctx, key) => {
  let strings = {
    /* globalstrings */
    "server_error": "Something went wrong! please try again later",
    /* SSH keys strings */
    "conflict_ssh": "this ssh key label is repeated! please change the label and try again",
    "invalid_ssh_key": "your ssh key is invalid! please change ssh key and try again",
    "successfully_added_ssh": "successfully added!",
    "delete_ssh_key": `You are about to delete (${ctx.label}) key. Are you sure ?`,
    /* Access tokens strings */
    "successfully_added_access_token": `Access token (${ctx.apiKeyLabel}) successfully added!`,
    "invalid_access_label": `(${ctx.apiKeyLabel}) is invalid! please choose another access token label "at least 2 characters"`,
    "conflict_access_token": `(${ctx.apiKeyLabel}) is repeated! please change the label and try again`,
    "delete_access_token": `You are about to delete (${ctx.label}) access token. Are you sure ?`,
    "successfully_updated_access_token": `Access token label successfully updated!`,
    "application_id_copied": "Application ID copied!",
    "secret_copied": "Secret code copied!",
    /* Authenticator strings */
    "invalid_code": "invalid code! please write the code you see in 2fa app",
    "setup_successfully": "your 2fa successfully enabled!",
    "confirm_delete": "Are you sure you want to remove your 2fa setup ?",
    "setup_onclick": "please scan the QR code with 2fa app and write the 6 digits code below",
    "setup_text": "Currently no Authenticator Application is configured on your profile.  Authenticator Application allows you to receive codes for your 2-Step Verification, even without internet connection and mobile service. Click SETUP button to configure your Authenticator Application."
  }
  return strings[key]
}